export default __webpack_public_path__ + "static/lilyBannerLondon-7f6559cf9bac5bd01c1cecbaa154725e.jpg";